import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { HxIcon } from '../icon/icon';

/**
 * Release Banner Component
 *
 * Compact dismissible banner for release notifications. Displays banner label with link to full release details.
 *
 * @example
 *   ```html
 *   <hx-release-banner
 *     label="New Update"
 *     viewLink="/releases"
 *     [openInNewTab]="false"
 *     (dismissed)="onDismiss()"
 *     (viewClicked)="onViewClick()"
 *   />
 *   ```;
 */
@Component({
  selector: 'hx-release-banner',
  standalone: true,
  imports: [CommonModule, HxIcon],
  templateUrl: './release-banner.html',
  styleUrls: ['./release-banner.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HxReleaseBanner {
  /** Banner label text */
  label = input<string>('New Update');

  /** Whether to display the warning treatment for an incident release. */
  warning = input<boolean>(false);

  /** Link to full release notes */
  viewLink = input<string>('/settings/releases');

  /** Whether to open link in new tab */
  openInNewTab = input<boolean>(false);

  /** Whether banner is visible */
  visible = input<boolean>(true);

  /** Emitted when user dismisses the banner */
  dismissed = output<void>();

  /** Emitted when user clicks the link */
  viewClicked = output<void>();

  onDismiss(): void {
    this.dismissed.emit();
  }

  onViewClick(): void {
    this.viewClicked.emit();
  }
}
